interface BaseQuestion {
  id: string
  question: string
  group: string
  required?: boolean
}

export interface RadioOption {
  value: string
  label: string
}

export interface RadioQuestion extends BaseQuestion {
  type: 'radio'
  title: string
  options: RadioOption[]
}

export interface CheckboxQuestion extends BaseQuestion {
  type: 'checkbox'
  title: string
  description?: string
  options: RadioOption[]
}

export interface RatingTableItem {
  id: string
  label: string
}

export interface RatingTableColumn {
  value: string
  label: string
}

export interface RatingTableQuestion extends BaseQuestion {
  type: 'rating_table'
  title: string
  description?: string
  items: RatingTableItem[]
  columns: RatingTableColumn[]
}

export interface TextAreaQuestion extends BaseQuestion {
  type: 'textarea'
  title: string
  placeholder?: string
  rows?: number
}

export type FormQuestion =
  | RadioQuestion
  | CheckboxQuestion
  | RatingTableQuestion
  | TextAreaQuestion

export interface FormPage {
  id: string
  questions: FormQuestion[]
}

export interface QuestionRendererProps {
  question: FormQuestion
  formData: Record<string, string>
  handleInputChange: (questionId: string, value: string) => void
  isSubmitting: boolean
  colors: {primary: string; secondary: string}
}

export const questionTitleStyles = {
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '24px',
  textAlign: 'center' as const,
  color: '#251F1F',
  mb: 0,
}
